/** Set after contact enquiry succeeds; cleared after login redirect or when leaving the thank-you flow. */
export const ENQUIRY_THANKS_PENDING_LOGIN_KEY = "blosm_enquiry_thanks_pending_login";
